// extracted by mini-css-extract-plugin
module.exports = {"Category":"Category_Category__2GfRJ","Header":"Category_Header__1kDm4"};